import { render, staticRenderFns } from "./InterviewSubTopic.vue?vue&type=template&id=67a6f39d&scoped=true"
import script from "./InterviewSubTopic.vue?vue&type=script&lang=js"
export * from "./InterviewSubTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a6f39d",
  null
  
)

export default component.exports